import appointmentReportReducer from "./appointmentReport";
import exportReportReducer from "./exportReports";
import innerScheduleReducer from "./innerScheduleReport";
import medicalPartnerReportReducer from "./medicalPartner";
import scheduleReportReducer from "./scheduleReport";
import staffReportReducer from "./staffReports";

const report = {
  medicalPartner: medicalPartnerReportReducer,
  staff: staffReportReducer,
  scheduleReport: scheduleReportReducer,
  appointmentReport: appointmentReportReducer,
  innerSchedule: innerScheduleReducer,
  staffReport: exportReportReducer,
};

export default report;
